'use client';

import { TopBar as SingleMatchTopBar } from '@/features/single-match/top-bar';
import { MatchPanel } from './matchpanel';
import { SportMatchModel } from '@nf/types/odds';
import { VideoDeviceType } from '@/services/streaming.service';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { MatchJackpotPanel } from './matchpanel-jackpot';
import { ReactPortal } from '@/components/widgets/react-portal';
import { useGetEnableMatchList } from '@/hooks/query/use-promotion-data';
import { useStreamingStore } from '@/store/streaming';
import { isDesktop } from 'react-device-detect';
import { SingleMatchGoldenDuelPool } from '@/features/promotion/golden-duel/components/single-match-golden-duel-pool';
import { useGoldenDuelSetting } from '@/hooks/query/golden-duel';
interface SportMatchPanelProps {
	match?: SportMatchModel;
	isAsideLayout: boolean;
	device: VideoDeviceType;
}

export const SportMatchPanel = (sportMatchPanelProps: SportMatchPanelProps) => {
	const { match, isAsideLayout, device } = sportMatchPanelProps;
	const { SiteConfigsData } = useGetSiteConfigs();
	const { data: jackpotEnableMatchList } = useGetEnableMatchList();
	const [streamingType] = useStreamingStore(
		state => [state.streamingType, state.streamingUrl]
	);
	const { isGoldenDuelSupported } = useGoldenDuelSetting();
	
	if (!match) {
		return;
	}

	const isGoldenDuel = isGoldenDuelSupported(match.GameID, match.LeagueId);

	return (
		<>
			{
				isAsideLayout ? (
					<div className="aside-panel aside-panel--video">
						<ReactPortal wrapperId="aside-topbar-portal">
							<SingleMatchTopBar match={match} isAsideLayout={isAsideLayout} />
						</ReactPortal>
						{
							isGoldenDuel && !streamingType && (
								<SingleMatchGoldenDuelPool matchId={match.MatchId} parentMatchId={match.Parentmatchid} />
							)
						}
						{
							SiteConfigsData?.EnableSingleMatchJackpot && (jackpotEnableMatchList?.find(x => x.MatchId == match.MatchId) ?? false) &&
								((streamingType && streamingType != 'Streamer' && !isDesktop) || (!streamingType) || isDesktop) ? (
									<MatchJackpotPanel match={match} />
								) : null
						}
						<MatchPanel match={match} isAsideLayout={isAsideLayout} device={device} />
					</div>
				) : (
					<>
						<SingleMatchTopBar match={match} isAsideLayout={isAsideLayout} />
						{
							isGoldenDuel && !streamingType && (
								<SingleMatchGoldenDuelPool matchId={match.MatchId} parentMatchId={match.Parentmatchid} />
							)
						}
						{
							SiteConfigsData?.EnableSingleMatchJackpot && (jackpotEnableMatchList?.find(x => x.MatchId == match.MatchId) ?? false) &&
								((streamingType && streamingType != 'Streamer' && !isDesktop) || (!streamingType) || isDesktop) ? (
									<MatchJackpotPanel match={match} />
								) : null
						}
						<MatchPanel match={match} isAsideLayout={isAsideLayout} device={device} />
					</>
				)
			}
		</>
	)
}